module.exports = __webpack_public_path__ + "static/media/jayesh-parekh.aef6eb36.jpeg";